'use strict';

module.exports = function(a){
  return (!a && a !== 0) ? '' : a.toString();
}
